/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{cursor:pointer}.main-container[_ngcontent-%COMP%]   .header[_ngcontent-%COMP%]   .branding[_ngcontent-%COMP%]{max-width:10rem!important}.table-wrapper[_ngcontent-%COMP%]{height:80%;width:100%;margin:0;padding:0;border:0}.table-wrapper[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:middle;text-align:center}.table-wrapper[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{max-width:90%;max-height:80%}\n/*# sourceMappingURL=login.component.css.map*/"];
export { styles as styles };
